import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../contexts/I18nContext";

export default function Footer() {
  const { t, lang } = useI18n();
  return (
    <footer className="relative mt-24 bg-[#0A192F] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <img
              src="/dikigoros-logo-white.png"
              alt="Dikigoros.io"
              className="h-9 w-auto"
              width={800}
              height={239}
            />
            <p className="text-sm text-blue-100/80 mt-3 leading-relaxed max-w-xs">
              {lang === "el"
                ? "Νομική ευφυΐα για δικηγόρους και δικηγορικά γραφεία Κύπρου."
                : "Legal intelligence for Cyprus lawyers and law firms."}
            </p>
          </div>
          <div>
            <div className="text-xs font-semibold tracking-[0.2em] uppercase text-blue-200">{lang === "el" ? "Προϊόν" : "Product"}</div>
            <ul className="mt-4 space-y-2 text-sm text-blue-50">
              <li><a href="/#features" className="hover:text-white">{t("nav.features")}</a></li>
              <li><a href="/#how" className="hover:text-white">{t("nav.how")}</a></li>
              <li><a href="/#pricing" className="hover:text-white">{t("nav.pricing")}</a></li>
            </ul>
          </div>
          <div>
            <div className="text-xs font-semibold tracking-[0.2em] uppercase text-blue-200">{lang === "el" ? "Εταιρεία" : "Company"}</div>
            <ul className="mt-4 space-y-2 text-sm text-blue-50">
              <li>Nicosia, Cyprus</li>
              <li>hello@dikigoros.io</li>
            </ul>
          </div>
          <div>
            <div className="text-xs font-semibold tracking-[0.2em] uppercase text-blue-200">{lang === "el" ? "Νομικά" : "Legal"}</div>
            <ul className="mt-4 space-y-2 text-sm text-blue-50">
              <li><Link to="/legal/terms" className="hover:text-white">{lang === "el" ? "Όροι" : "Terms"}</Link></li>
              <li><Link to="/legal/privacy" className="hover:text-white">{lang === "el" ? "Πολιτική Απορρήτου" : "Privacy"}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-blue-200/80">
          <div>© {new Date().getFullYear()} Dikigoros.io · {lang === "el" ? "Όλα τα δικαιώματα κατοχυρωμένα." : "All rights reserved."}</div>
          <div>{lang === "el" ? "Φτιαγμένο για την Κύπρο." : "Built for Cyprus."}</div>
        </div>
      </div>
    </footer>
  );
}
